// extracted by css-extract-rspack-plugin
export default {"skeleton":"skeleton-FMR80z","loading":"loading-FKdv8Z"};